<!-- 中奖用户列表PC端组件 -->
<template>
  <modal-normal
    class="plv-iar-welfare-lottery__winner-list"
    @close="$emit('close')"
  >
    <template #header>
      <span class="plv-iar-welfare-lottery__modal__back-btn--black" @click="$emit('back')"></span>
      <h2 class="plv-iar-welfare-lottery__modal__title--center">{{ iarTrans('welfareLottery.winnerList') }}</h2>
    </template>
    <template #body>
      <div class="plv-iar-welfare-lottery__winner-list__body">
        <template v-if="isGroup">
          <div class="plv-iar-welfare-lottery__winner-list__group">
            <div
              v-for="(item, index) in groupList"
              :key="`group-${index}`"
              class="plv-iar-welfare-lottery__winner-list__group__item"
              :class="{
                'plv-iar-welfare-lottery__winner-list__group__item--active': item.id === currentGroupId
              }"
              @click="switchGroup(item)"
            >{{ item.title }}({{ item.count || 0 }})</div>
          </div>
        </template>
        <ul
          v-if="winnerGroups.length"
          ref="scrollWrap"
          class="plv-iar-welfare-lottery__winner-list__main"
          @scroll="onScroll"
        >
          <li v-for="(group, index) in winnerGroups" :key="index">
            <span v-for="(user, userIndex) in group" :key="userIndex">
              {{ user.viewerName }}
            </span>
          </li>
        </ul>
        <div v-else-if="!isLoading" class="plv-iar-welfare-lottery__winner-list--no-data">{{ iarTrans('welfareLottery.noWinnerList') }}</div>
      </div>
    </template>
  </modal-normal>
</template>

<script>
import ModalNormal from '../modal-normal/PcModalNormal.vue';
import mixin from './mixin';

export default {
  components: {
    ModalNormal,
  },
  mixins: [mixin],
};
</script>
<style lang="scss">
@import './base.scss';
.plv-iar-welfare-lottery__winner-list {
  .plv-iar-welfare-lottery__modal__back-btn--black {
    top: 13px;
  }
}
.plv-iar-welfare-lottery__winner-list__group__item {
  cursor: pointer;
}
.plv-iar-welfare-lottery__winner-list__group {
  overflow-y: hidden;
  &::-webkit-scrollbar {
    width: 8px;
    height: 8px;
    cursor: pointer;
  }
  &::-webkit-scrollbar-thumb {
    background: #CFD8DC;
    border: 2px solid #ffe8de;
    border-radius: 8px;
  }
  &::-webkit-scrollbar-track-piece {
    background: #ffe8de;
  }
}
</style>
